(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('volbiv-focus-packs')) {
  customElements.define('volbiv-focus-packs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const requestedVariant = new URLSearchParams(window.location.search).get('focus_variant');
      const requestedOption = Array.from(this.querySelectorAll('input[name="id"]')).find(
        (option) => option.value === requestedVariant && !option.disabled
      );
      if (requestedOption) requestedOption.checked = true;
      this.addEventListener('change', () => this.update());
      this.querySelector('form').addEventListener('submit', (event) => {
        if (this.hasAttribute('data-preview-only')) event.preventDefault();
      });
      this.update();
    }
    update() {
      const selected = this.querySelector('input[name="id"]:checked');
      if (!selected) return;
      this.querySelector('[data-selected-total]').textContent = selected.dataset.total;
      const priceBlock = this.closest('.shopify-section')?.querySelector('product-price[data-product-id="7883417616467"]');
      if (priceBlock) {
        const currentPrice = priceBlock.querySelector('.price');
        const comparePrice = priceBlock.querySelector('.compare-at-price');
        if (currentPrice) currentPrice.textContent = selected.dataset.total;
        if (comparePrice) comparePrice.textContent = selected.dataset.compare;
        priceBlock.setAttribute('aria-live', 'polite');
      }
      const shipping = this.querySelector('[data-shipping]');
      shipping.textContent = Number(selected.dataset.boxes) > 1 ? shipping.dataset.reached : shipping.dataset.under;
      this.querySelector('button[type="submit"]').disabled = this.hasAttribute('data-preview-only') || selected.disabled;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
